import React from 'react';

const bellyOptions = [
  { label: 'Small', value: 'Small', img: '/assets/images/nobelly.png' },
  { label: 'Medium', value: 'Medium', img: '/assets/images/prettyfit.png' },
  { label: 'Large', value: 'Large', img: '/assets/images/mediumbelly.png' },
  { label: 'Extra Large', value: 'Extra Large', img: '/assets/images/significan.png' },
];

const StepBellySize = ({ data, setData, onNext, onPrev }) => {
  const handleSelect = (size) => {
    setData(prev => ({
      ...prev,
      bellySize: size
    }));
  };

  const handleSkip = () => {
    setData(prev => ({
      ...prev,
      bellySize: null
    }));
    onNext();
  };

  return (
    <main className="rbt-main-wrapper">
      <div className="container custom-checkout-container">
        <div className="row">
          <div className="">
            <div className="belly-size-container">
              <h3 className="belly-size-title">What is your belly size?</h3>

              <div className="belly-size-grid">
                {bellyOptions.map((option) => (
                  <button
                    key={option.value}
                    className={`belly-size-btn ${data.bellySize === option.value ? 'active' : ''}`}
                    onClick={() => handleSelect(option.value)}
                  >
                    <img src={option.img} alt={`${option.label} Belly`} />
                    <span>{option.label}</span>
                  </button>
                ))}
              </div>

              <button className="skip-btn mt-3" onClick={handleSkip}>
                I'm not sure, skip this question
              </button>

              <div className="nav-buttons mt-4">
                <button className="belly-size-prev-btn" onClick={onPrev}>
                  Prev
                </button>
                <button
                  className="belly-size-next-btn"
                  onClick={onNext}
                  disabled={!data.bellySize}
                >
                  Next
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default StepBellySize;
